module.exports = __webpack_public_path__ + "static/media/book-reader.2a5926ed.svg";